import React from "react"
import HeadingSkeleton from "../../../components/skeletons/HeadingSkeleton";
import AvatarSkeleton from "../../../components/skeletons/AvatarSkeleton";
import {Form} from "react-bootstrap";
import {BackIcon} from "../../../../assets/icons/profileIcons";
import {Col, Row} from "antd";
import InputFieldSkeleton from "../../../components/skeletons/InputFieldSkeleton";

export default function ClientNoteDetailsSkeleton() {
    return(
        <>
            <Form>
                <div className="main_div_client_details">
                    <div className="inner_div">
                        <div className="header">
              <span>
                <BackIcon />
              </span>
                            <h3><HeadingSkeleton height={10} maxWidth={100} /></h3>
                        </div>

                        <Row gutter={[16, 16]} style={{ marginTop: "20px" }}>
                            <Col xs={24} lg={24} xl={24} md={24}>
                                <div className="col_1_div">
                                    <div className="inner_div_col_1">
                                        <div className="client_info">
                                            <div className="inner_client_info">
                                                <p><HeadingSkeleton height={10} maxWidth={100} /></p>
                                            </div>
                                            <div className="profile">
                                                <div className="img_div">
                                                   <AvatarSkeleton width={50} height={50} avatarShape={'circle'}/>
                                                </div>
                                                <div>
                                                    <p><HeadingSkeleton height={10} maxWidth={100} /></p>
                                                    <p className="para"><HeadingSkeleton height={10} maxWidth={100} /></p>
                                                </div>
                                            </div>
                                            <div className="events_section">
                                                <div className="inner_events">
                                                    <HeadingSkeleton height={10} maxWidth={10} />
                                                    <p><HeadingSkeleton height={10} maxWidth={100} /></p>
                                                </div>
                                                <p>
                                                    <HeadingSkeleton height={10} maxWidth={100} />
                                                </p>
                                            </div>
                                            <div className="events_section">
                                                <div className="inner_events">
                                                    <HeadingSkeleton height={10} maxWidth={10} />
                                                    <p><HeadingSkeleton height={10} maxWidth={100} /></p>
                                                </div>

                                                <p>
                                                    <HeadingSkeleton height={10} maxWidth={100} />
                                                </p>
                                            </div>
                                        </div>

                                    </div>
                                </div>
                            </Col>
                            <Col xs={24} lg={12} xl={12} md={24}>
                                <div className={'col_1_div'}>
                                    <div className={'inner_div_col_1'}>
                                        <div>
                                            <div className={"dfields"}>
                                                <InputFieldSkeleton/>
                                            </div>
                                            <div className={"dfields"}>
                                                <InputFieldSkeleton/>
                                            </div>
                                        </div>
                                        <div className="session_main_div">
                                            <h5><HeadingSkeleton height={10} maxWidth={100} /></h5>
                                            <div className={"dfields"}>
                                                <InputFieldSkeleton/>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className={"dfields"}>
                                    <InputFieldSkeleton/>
                                </div>
                            </Col>
                            <Col xs={24} lg={12} xl={12} md={24}>
                                <div className="col_1_div">
                                    <div className="inner_div_col_1">
                                        <div className="form_div">
                                            <h5><HeadingSkeleton height={10} maxWidth={100} /></h5>
                                            <div className={"dfields"}>
                                                <InputFieldSkeleton/>
                                            </div>
                                        </div>
                                        <div className="form_div">
                                            <h5><HeadingSkeleton height={10} maxWidth={100} /></h5>
                                            <div className={"dfields"}>
                                                <InputFieldSkeleton/>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </Col>
                        </Row>
                    </div>
                </div>
            </Form>
        </>
    )
}